import React, { useEffect, useReducer } from "react";
import useSWR from "swr";
import { JsonLdTags } from "../../components/JsonLd";
import Reputation from "./Reputation";

export const reducer = (state, action) => {
  switch (action.type) {
    case "SET_FILTER":
      return Object.assign({}, state, { filter: action.payload, page: 1 });
    case "LOAD_MORE":
      return Object.assign({}, state, { page: state.page + 1 });
    case "NO_MORE":
      return Object.assign({}, state, { noMore: true });
    case "LOADED_REVIEWS":
      let reviews = state.reviews.concat(action.payload);
      return Object.assign({}, state, { reviews });
    default:
      return state;
  }
};

export const defaultAppState = { filter: null, reviews: [], page: 0, noMore: false };
export const AppContext = React.createContext(defaultAppState);

const All = (props) => {
  const fetcher = (...args) => fetch(...args).then((r) => r.json());
  const { data } = useSWR(`${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}.json?widget=reviews&currentLocationReviewsOnly=${props.currentLocationReviewsOnly}`, fetcher, {
    revalidateOnFocus: false,
  });

  const [state, dispatch] = useReducer(reducer, defaultAppState);

  useEffect(() => {
    dispatch({ type: "LOAD_MORE" });
  }, []);

  if (!data) {
    return null;
  }

  const { merchant } = data;
  return (
    <AppContext.Provider value={{ state, dispatch, settings: { ...props } }}>
      <JsonLdTags merchant={merchant} reviews={state.reviews} />
      <Reputation {...props} {...data} />
    </AppContext.Provider>
  );
};

export default All;



// WEBPACK FOOTER //
// ./src/containers/All/index.jsx